/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';

// Component imports
import NotificationSound from '../../assets/sounds/livechat_notification.mp3';

// Misc imports
import { NAV_LOGIN, NAV_LOGOUT } from '../../constants/navigation';
import { useDispatch } from 'react-redux';
import { setOrganization } from '../../store/auth/authActions';
import { IS_LIVECHAT_CONSOLE_ONLY, IS_LIVECHAT_CONVERSATIONS_ENABLED } from '../../constants/env';

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  isAuthenticated,
  ...rest
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { orgId } = useParams();

  const { pathname, search } = location;
  const next = encodeURIComponent(pathname + search);

  // Handle organization change
  useEffect(() => {
    if (orgId) {
      dispatch(setOrganization(orgId, navigate));
    }
  }, [orgId]);

  return (
    isAuthenticated ? (
      <Layout {...rest}>
        <Component />
        {
          (IS_LIVECHAT_CONSOLE_ONLY || IS_LIVECHAT_CONVERSATIONS_ENABLED)
            ? <audio
              id="hbfNotificationSound"
              src={NotificationSound}
              preload="auto"
            />
            : null
        }
      </Layout>
    ) : (
      <Navigate
        to={{
          pathname: NAV_LOGIN,
          search: next && !pathname.startsWith(NAV_LOGOUT) ? `next=${next}` : '',
          state: { from: location }
        }}
        replace
      />
    )
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func,
  location: PropTypes.object,
  layout: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  computedMatch: PropTypes.object
};

export default PrivateRoute;
